import React, { version } from "react";
import axios from "axios";
import { Container, Row, Col } from "shards-react";
import PageTitle from "../../components/common/PageTitle";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import LinearProgress from "@material-ui/core/LinearProgress";
import api from "../common/api";
import MediaComponent from "../common/Media";
import HansaMediaComponent from "../common/HansaMedia";
import BasicDataComponent from "../common/vehicles/BasicData";
import ExpirationsComponent from "../common/vehicles/Expirations";
import WarrantyComponent from "../common/vehicles/Warranty";
import ServiceComponent from "../common/vehicles/Service";
import ClientComponent from "../common/vehicles/Client";
import InsuranceComponent from "../common/vehicles/Insurance";
import RelatedContactComponent from "../common/vehicles/RelatedContact";
import EquipmentComponent from "../common/vehicles/Equipment";
import PreferencesComponent from "../common/vehicles/Preferences";
import AddressesComponent from "../common/vehicles/Addresses";
import Backdrop from "@material-ui/core/Backdrop";
import TiersComponent from "../common/vehicles/Tiers";
import FinancialAndSaleComponent from "../common/vehicles/FinancialSale";
import PurchaseComponent from "../common/vehicles/Purchase";
import SalesData from "../common/vehicles/SalesData";
import BookingComponent from "../common/vehicles/Booking";

class VehicleForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      basic_data: {
        id: "",
        plate: "",
        code: "",
        color: "",
        version_id: "",
        is_fleet_owner: "",
        is_owner: "",
        chassis: "",
        motor_number: "",
        year: "",
        province_id: "",
        condition_type: "",
        vtv_last_city_id: "",
        plate_city_id: "",
        vehicle_state_id: "",
        plate_date: "",
        version: {
          variation: {}
        }
      },
      expirations: {
        fire_extinguisher_due_date: "",
        rto_due_date: "",
        vtv_km_expiration: "",
        vtv_last_city_id: "",
        plate_city_id: ""
      },
      sap_projects: [],
      condition_types: [],
      warranty: { warranty_up_to_km: "", warranty_up_to_date: "" },
      client_data: { hansa_start_date: "" },
      insurance: { insurance_id: "", insurance_ammount: "" },
      insurance_history: [],
      related_contact: {
        subcontact_ids: [
          {
            subcontact_id: "",
            relation_type_id: "",
            start_date: new Date().toISOString().slice(0, 10),
            end_date: "",
            has_car_doc_documents: "",
            car_doc_document_number: "",
            car_doc_documents_due_date: ""
          }
        ]
      },
      preferences: { provider_ids: [{ provider_id: "" }] },
      not_preferences: { provider_ids: [{ provider_id: "" }] },
      equipment: {
        vehicle_equipment_type_ids: [{ vehicle_equipment_type_id: "" }],
        gps_provider_id: ""
      },
      service: {},
      provinces: [],
      clients: [],
      addresses: { address_ids: [{ address_id: "" }] },
      contact_addresses: [],
      tiers_data: { tiers_to_show: 4, tiers: [] },
      financial_sales: {},
      purchase: {},
      sales_data: { has_completed_documentation: 1 },
      errors: "",
      cities: [],
      vtv_cities: [],
      insurances: [],
      brands: [],
      models: [],
      versions: [],
      colors: [],
      fleet_types: [
        { id: 1, name: "Propio" },
        { id: 0, name: "Terceros" }
      ],
      owner_types: [
        { id: "", name: "Sin especificar" },
        { id: "AutoCorp", name: "AutoCorp" },
        { id: "Empresa", name: "Empresa" },
        { id: "Usuario", name: "Usuario" },
        { id: "Terceros", name: "Terceros" },
        { id: "Leasing", name: "Leasing" },
        { id: "Prenda", name: "Prenda" }
      ],
      vehicle_states: [],
      condition_types: [
        { id: "EXCELENTE", name: "EXCELENTE" },
        { id: "MUY BUENO", name: "MUY BUENO" },
        { id: "BUENO", name: "BUENO" },
        { id: "REGULAR", name: "REGULAR" },
        { id: "MALO", name: "MALO" }
      ],
      warranty_states: [
        { id: 1, name: "Vigente" },
        { id: 0, name: "No vigente" }
      ],
      service_origins: [
        { id: "APP", name: "APP" },
        { id: "EFLEET", name: "EFLEET" }
      ],
      send_expiriation_mailing_options: [
        { id: 0, name: "No" },
        { id: 1, name: "Si" }
      ],
      mailing_weeks: [
        { id: "Semana 1", name: "Semana 1" },
        { id: "Semana 2", name: "Semana 2" },
        { id: "Semana 3", name: "Semana 3" },
        { id: "Semana 4", name: "Semana 4" },
        { id: "", name: "" }
      ],
      contracts: [],
      authorization_matrices: [],
      policies: [],
      provider: {},
      gps_providers: [],
      client_structures: [],
      has_circulation: [
        { id: 1, name: "Si" },
        { id: 0, name: "No" }
      ],
      has_duplicated_key_boolean: [
        { id: 1, name: "Si" },
        { id: 0, name: "No" }
      ],
      subcontact_relation_types: [],
      subcontacts: [],
      submitted: false,
      activeStep: 0,
      loading: true,
      backdrop: false,
      dialogOpen: false,
      cancel_dialog: false,
      plate_exists: false,
      action: "new",
      errorMessage: "",
      fuel_providers: [],
      authorization_matrices_ac: [],
      active_booking: [{}],
      policies_ac: [],
      media: [],
      wallet: [],
      comment: "",
      maintenance_plans: [],
      tier_variations: [],
      tier_brands: [],
      tier_types: [],
      investor_providers: [],
      comments: [],
      buyer_contacts: {
        loading: false,
        open: false,
        options: [{ hansa_name: "" }],
        provider: {}
      },
      reseller_contacts: {
        loading: true,
        open: false,
        options: [],
        provider: {}
      },
      carstore_contacts: {
        loading: false,
        open: false,
        options: [{ hansa_name: "" }],
        provider: {}
      },
      items_to_delete: {
        addresses: [],
        providers: { preferred: [], not_preferenced: [] },
        subcontacts: [],
        vehicle_equipment_types: []
      }
    };

    this.addNewItem = this.addNewItem.bind(this);
    this.removeItem = this.removeItem.bind(this);
    this.handleUpload = this.handleUpload.bind(this);
    this.handleWalletUpload = this.handleWalletUpload.bind(this);
  }

  async componentDidMount() {
    var params = this.getParams();
    var vehicle_id = params.id;
    this.setState({ vehicle_id: vehicle_id });
    this.setParams(vehicle_id);
    var view = params.view;
    if (vehicle_id !== undefined) {
      var action = view === "1" ? "view" : "edit";
      await this.setVehicle(vehicle_id);
      this.setState({ action: action });
      this.setState({ disabled: view });
    } else {
      this.setState({ action: "new" });
    }
    this.setState({ loading: false });
  }

  async setParams(vehicle_id = "") {
    const token = localStorage.getItem("userToken");
    var results = axios
      .all([
        axios.get(api.brands().index(), {
          headers: { Authorization: `Bearer ${token}` }
        }),
        axios.get(api.vehicles().colors(), {
          headers: { Authorization: `Bearer ${token}` }
        }),
        axios.get(api.vehicles().states(vehicle_id), {
          headers: { Authorization: `Bearer ${token}` }
        }),
        axios.get(api.contracts, {
          headers: { Authorization: `Bearer ${token}` }
        }),
        axios.get(api.vehicles().subcontact_relation_types(), {
          headers: { Authorization: `Bearer ${token}` }
        }),
        axios.get(api.insurances().index(), {
          headers: { Authorization: `Bearer ${token}` }
        }),
        axios.get(api.vehicles().equipment_types(), {
          headers: { Authorization: `Bearer ${token}` }
        }),
        //axios.get(api.providers().all(),{ headers: {"Authorization" : `Bearer ${token}`} }),
        axios.get(api.vehicles().gps_providers(), {
          headers: { Authorization: `Bearer ${token}` }
        }),
        axios.get(api.provinces().get(), {
          headers: { Authorization: `Bearer ${token}` }
        }),
        //		     	axios.get(api.cities,{ headers: {"Authorization" : `Bearer ${token}`} }),
        axios.get(
          api
            .clients()
            .index(1, "", "Cliente negocios", "business_name", "ASC", 100000),
          { headers: { Authorization: `Bearer ${token}` } }
        ),
        axios.get(api.maintenance_plans().index(), {
          headers: { Authorization: `Bearer ${token}` }
        }),
        axios.get(api.contract().matrices(0), {
          headers: { Authorization: `Bearer ${token}` }
        }),
        axios.get(api.contract().policies(0), {
          headers: { Authorization: `Bearer ${token}` }
        }),
        axios.get(api.vehicles().fuel_providers(), {
          headers: { Authorization: `Bearer ${token}` }
        }),
        axios.get(api.vehicles().tier_variations(), {
          headers: { Authorization: `Bearer ${token}` }
        }),
        axios.get(api.vehicles().tier_types(), {
          headers: { Authorization: `Bearer ${token}` }
        }),
        axios.get(api.vehicles().tier_brands(), {
          headers: { Authorization: `Bearer ${token}` }
        }),
        axios.get(api.providers().index("", "", "Inversor", "", "", 1000, ""), {
          headers: { Authorization: `Bearer ${token}` }
        }),
        axios.get(api.sapProjects().index(), {
          headers: { Authorization: `Bearer ${token}` }
        }),
        axios.get(api.sapProjects().index(), {
          headers: { Authorization: `Bearer ${token}` }
        }),
        axios.get(
          api.clients().index(1, "", 6, "business_name", "ASC", 100000),
          { headers: { Authorization: `Bearer ${token}` } }
        ),
        axios.get(
          api.clients().index(1, "", 5, "business_name", "ASC", 100000),
          { headers: { Authorization: `Bearer ${token}` } }
        )
      ])
      .then(
        axios.spread((...responses) => {
          const brands = responses[0].data;
          const colors = responses[1].data;
          const vehicle_states = responses[2].data;
          const contracts = responses[3].data;
          const subcontact_relation_types = responses[4].data;
          const insurances = responses[5].data;
          const equipment_types = responses[6].data;
          //		  const providers = responses[7].data;
          const providers = {
            loading: false,
            open: false,
            options: [{ business_name: "" }],
            provider: {}
          };
          const gps_providers = responses[7].data;
          const provinces = responses[8].data;
          //		  const cities = responses[10].data;
          const clients = responses[9].data.data;
          const maintenance_plans = responses[10].data;
          const authorization_matrices = [];
          const policies = [];
          contracts.map((val, idx) => {
            val.authorization_matrixes.map((val, idx) => {
              authorization_matrices.push({
                id: val.id,
                name: val.name,
                contract_id: val.contract_id
              });
            });
            val.policies.map((val, idx) => {
              policies.push({
                id: val.id,
                name: val.name,
                contract_id: val.contract_id
              });
            });
          });
          const authorization_matrices_ac = responses[11].data;
          const policies_ac = responses[12].data;
          const fuel_providers = responses[13].data;
          const tier_variations = responses[14].data;
          const tier_types = responses[15].data;
          const tier_brands = responses[16].data;
          const investor_providers = responses[17].data.data;
          const sap_projects = responses[18].data;
          const mapClientOption = d => ({
            ...d,
            business_name: d.business_name || d.hansa_name || "",
            hansa_name: d.hansa_name || d.business_name || "",
            contact_id: d.contact_id || d.id
          });
          const resellerOptions = (responses[18].data.data || []).map(
            mapClientOption
          );
          const rebateOptions = (responses[19].data.data || []).map(
            mapClientOption
          );
          const mergedOptions = [...resellerOptions, ...rebateOptions].reduce(
            (acc, option) => {
              const contactId = String(option.contact_id);
              if (!acc.seen.has(contactId)) {
                acc.seen.add(contactId);
                acc.options.push(option);
              }
              return acc;
            },
            { seen: new Set(), options: [] }
          ).options;
          const reseller_contacts = {
            loading: false,
            open: false,
            options: mergedOptions.sort((a, b) =>
              (a.business_name || "").localeCompare(b.business_name || "", "es", {
                sensitivity: "base"
              })
            ),
            provider: {}
          };
          var tiers = [];
          tier_types.map((val, idx) => {
            tiers.push({
              tier_type_id: val.id,
              last_tier_variation_id: "",
              last_km_date: "",
              last_km_change: "",
              next_km_change: "",
              next_date_change: ""
            });
          });
          var tiers_data = { tiers_to_show: 4, tiers: tiers };
          this.setState({
            brands,
            colors,
            vehicle_states,
            contracts,
            authorization_matrices,
            policies,
            subcontact_relation_types,
            insurances,
            equipment_types,
            providers,
            gps_providers,
            provinces,
            //cities,
            clients,
            maintenance_plans,
            authorization_matrices_ac,
            policies_ac,
            fuel_providers,
            tier_variations,
            tier_brands,
            tiers_data,
            investor_providers,
            sap_projects,
            reseller_contacts
          });
          var vehicle_state = vehicle_states.filter(
            state =>
              parseInt(state.id) ===
              parseInt(this.state.basic_data.vehicle_state_id)
          );
          this.setState({ vehicle_state: vehicle_state });
        })
      );
  }

  getParams() {
    return this.props.match.params;
  }

  getApi(url, params) {
    const token = localStorage.getItem("userToken");
    return axios
      .get(url, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => {
        res.data = Object.values(res.data);
        return res.data;
      })
      .catch(err => {
        console.log(err);
      });
  }

  async getVehicle(id) {
    return await this.getApi(api.vehicles().get(id));
  }

  async getCities(province_id) {
    return await this.getApi(api.provinces().cities(province_id));
  }

  async getBrand(brand_id) {
    return await this.getApi(api.brands().get(brand_id));
  }

  async setVehicle(id) {
    var vehicle_data = await this.getVehicle(id);
    vehicle_data = vehicle_data[0];
    var vehicle_id = vehicle_data["id"];
    this.setState({ vehicle_data: vehicle_data });
    this.setState({ vehicle_id: vehicle_id });
    var models = await this.refreshModels(
      vehicle_data.version.variation.brand_id
    );
    this.setState({ models });
    var versions = await this.refreshVersions(
      vehicle_data.version.variation.id
    );
    this.setState({ versions });
    var client_id = null;
    if (vehicle_data.contract_id) {
      //client_id = await this.getClientByContract(vehicle_data.contract_id);
      client_id = vehicle_data.contract.contact_id;
    }
    if (vehicle_data.active_booking && vehicle_data.active_booking[0]) {
      client_id = vehicle_data.active_booking[0].client.contact_id;
    }
    var result = this.getClient(client_id);
    var subcontacts = [];
    var related_contacts = [];
    vehicle_data.subcontacts.map((val, idx) => {
      var subcontact = {
        subcontact_id: val.subcontact_id,
        relation_type_id: val.relation_type_id,
        start_date: val.start_date,
        end_date: val.end_date,
        has_car_doc_documents: val.has_car_doc_documents,
        car_doc_document_number: val.car_doc_document_number,
        car_doc_documents_due_date: val.car_doc_documents_due_date
      };
      subcontacts.push(subcontact);
      subcontact.hansa_code = val.hansa_code;
      subcontact.id = val.id;
      subcontact.firstname = val.subcontact.firstname;
      subcontact.lastname = val.subcontact.lastname;
      related_contacts.push(subcontact);
    });
    if (subcontacts.length === 0) {
      subcontacts.push({
        subcontact_id: "",
        relation_type_id: "",
        start_date: "",
        end_date: "",
        has_car_doc_documents: "",
        car_doc_document_number: "",
        car_doc_documents_due_date: ""
      });
    }
    if (related_contacts.length === 0) {
      related_contacts.push({
        subcontact_id: "",
        relation_type_id: "",
        start_date: "",
        end_date: "",
        has_car_doc_documents: "",
        car_doc_document_number: "",
        car_doc_documents_due_date: ""
      });
    }
    var equipments = [];
    vehicle_data.equipments.map((val, idx) => {
      equipments.push({
        vehicle_equipment_type_id: val.vehicle_equipment_type_id
      });
    });
    var providers = [];
    var providers_not_prefered = [];
    vehicle_data.providers.map((val, idx) => {
      if (val.is_prefered === 1 || val.is_prefered === "1") {
        providers.push({
          provider_id: val.provider_id,
          business_name: val.provider.business_name
        });
      } else {
        providers_not_prefered.push({
          provider_id: val.provider_id,
          business_name: val.provider.business_name
        });
      }
    });

    var addresses = [];
    vehicle_data.address.map((val, idx) => {
      addresses.push({ address_id: val.address_id });
    });

    if (addresses.length === 0) {
      addresses.push({ address_id: "" });
    }

    if (providers.length === 0) {
      providers.push({ provider_id: "" });
    }
    if (providers_not_prefered.length === 0) {
      providers_not_prefered.push({ provider_id: "" });
    }

    var vtv_province_id = vehicle_data.vtv_city
      ? vehicle_data.vtv_city.province_id
      : "";
    var plate_province_id = vehicle_data.plate_city
      ? vehicle_data.plate_city.province_id
      : "";
    var vtv_cities = [];
    if (vtv_province_id !== "") {
      vtv_cities = await this.getCities(vtv_province_id);
    }
    var cities = [];
    if (plate_province_id !== "") {
      cities = await this.getCities(plate_province_id);
    }

    /*		
		this.state.cities.map((val,idx)=>{
			if(parseInt(val.id) === parseInt(vehicle_data.vtv_last_city_id)){
				vtv_province_id = val.provinces.id
			}	

			if(parseInt(val.id) === parseInt(vehicle_data.plate_city_id)){
				plate_province_id = val.provinces.id
			}		
		})
*/

    if (vehicle_data.contract) {
      vehicle_data.contract.hansa_end_date = this.formatDate(
        vehicle_data.contract.hansa_end_date
      );
      vehicle_data.contract.hansa_start_date = this.formatDate(
        vehicle_data.contract.hansa_start_date
      );
    }

    var tiers_data = this.state.tiers_data;
    vehicle_data.tiers.map((val, idx) => {
      tiers_data.tiers.map((val2, idx2) => {
        if (parseInt(val2.tier_type_id) === parseInt(val.tier_type_id)) {
          tiers_data.tiers[idx2] = val;
          tiers_data.tiers[idx2]["last_tier_variation_id"] =
            val.last_tier_variation_id;
        }
      });
    });

    var vehicle_state = this.state.vehicle_states.filter(
      state => parseInt(state.id) === parseInt(vehicle_data.vehicle_state_id)
    );
    if (vehicle_state) {
      vehicle_state = vehicle_state[0];
    }
    var buyer_contacts = this.state.buyer_contacts;
    if (vehicle_data.purchase) {
      var carstore_contacts = this.state.carstore_contacts;
      if (vehicle_data.purchase.contact_id) {
        carstore_contacts.options[0].hansa_name =
          vehicle_data.purchase.car_store_contact.hansa_name;
        carstore_contacts.options[0].id =
          vehicle_data.purchase.car_store_contact.id;
      }
      this.setState({
        purchase: {
          request_date: vehicle_data.purchase.request_date,
          estimated_invoice_date: vehicle_data.purchase.estimated_invoice_date,
          invoice_date: vehicle_data.purchase.invoice_date,
          estimated_plate_date: vehicle_data.purchase.estimated_plate_date,
          payment_date: vehicle_data.purchase.payment_date,
          documents_reception_date:
            vehicle_data.purchase.documents_reception_date,
          plate_delivered_date: vehicle_data.purchase.plate_delivered_date,
          no_usage: vehicle_data.purchase.no_usage
            ? vehicle_data.purchase.no_usage
            : 0,
          vehicle_delivered_date: vehicle_data.purchase.vehicle_delivered_date,
          invoice_province_id: vehicle_data.purchase.invoice_province_id,
          invoice_number: vehicle_data.purchase.invoice_number,
          due_date: vehicle_data.purchase.due_date,
          carstore_name: vehicle_data.purchase.carstore_name,
          price_list: vehicle_data.purchase.price_list,
          price_buy: vehicle_data.purchase.price_buy,
          contact_id: vehicle_data.purchase.contact_id,
          audits: vehicle_data.purchase.audits,
          carstore_contacts: carstore_contacts,
          invoice_reception_date: vehicle_data.purchase.invoice_reception_date,
          estimated_vehicle_delivered_date:
            vehicle_data.purchase.estimated_vehicle_delivered_date,
          destiny_client_id: vehicle_data.purchase.destiny_client_id
        }
      });
    }
    if (vehicle_data.sales_data) {
      if (vehicle_data.sales_data.buyer_id) {
        buyer_contacts.options[0].hansa_name =
          vehicle_data.sales_data.buyer.hansa_name;
        buyer_contacts.options[0].id = vehicle_data.sales_data.buyer_id;
      }

      this.setState({
        buyer_contacts: buyer_contacts,
        sales_data: {
          reseller_id: vehicle_data.sales_data.reseller_id
            ? vehicle_data.sales_data.reseller_id
            : "",
          reseller_payment_date: vehicle_data.sales_data.reseller_payment_date
            ? vehicle_data.sales_data.reseller_payment_date
            : "",
          reseller_delivery_date: vehicle_data.sales_data.reseller_delivery_date
            ? vehicle_data.sales_data.reseller_delivery_date
            : "",
          reseller_delivery_km: vehicle_data.sales_data.reseller_delivery_km
            ? vehicle_data.sales_data.reseller_delivery_km
            : "",
          resale_price: vehicle_data.sales_data.resale_price
            ? vehicle_data.sales_data.resale_price
            : "",
          is_consignment: vehicle_data.sales_data.is_consignment
            ? vehicle_data.sales_data.is_consignment
            : 0,
          buyer_id: vehicle_data.sales_data.buyer_id
            ? vehicle_data.sales_data.buyer_id
            : "",
          buyer_payment_date: vehicle_data.sales_data.buyer_payment_date
            ? vehicle_data.sales_data.buyer_payment_date
            : "",
          buyer_sale_date: vehicle_data.sales_data.buyer_sale_date
            ? vehicle_data.sales_data.buyer_sale_date
            : "",
          buyer_sale_km: vehicle_data.sales_data.buyer_sale_km
            ? vehicle_data.sales_data.buyer_sale_km
            : "",
          buyer_price: vehicle_data.sales_data.buyer_price
            ? vehicle_data.sales_data.buyer_price
            : "",
          has_completed_documentation: vehicle_data.sales_data
            .has_completed_documentation
            ? vehicle_data.sales_data.has_completed_documentation
            : 0,
          missing_documentation: vehicle_data.sales_data.missing_documentation
            ? vehicle_data.sales_data.missing_documentation
            : "",
          comments: vehicle_data.sales_data.comments,
          is_resale: parseInt(vehicle_data.sales_data.reseller_id) > 0 ? 1 : 2
          //is_resale: 2
        }
      });
    }
    this.setState({
      basic_data: {
        id: vehicle_data.id,
        plate: vehicle_data.plate,
        code: vehicle_data.code,
        sap_code: vehicle_data.sap_code ? vehicle_data.sap_code : "",
        sap_dimension: vehicle_data.sap_dimension
          ? vehicle_data.sap_dimension
          : "",
        color: vehicle_data.color ? vehicle_data.color : "",
        chassis: vehicle_data.chassis ? vehicle_data.chassis : "",
        motor_number: vehicle_data.motor_number,
        year: vehicle_data.year ? vehicle_data.year : "",
        vtv_last_date: vehicle_data.vtv_last_date,
        plate_date: vehicle_data.plate_date,
        is_fleet_owner: vehicle_data.is_fleet_owner,
        is_owner: vehicle_data.is_owner,
        last_km: vehicle_data.last_km,
        last_km_origin: "EFLEET",
        last_km_date: vehicle_data.last_km_date,
        condition_type: vehicle_data.condition_type,
        version_id: vehicle_data.version_id,
        vehicle_state_id: vehicle_data.vehicle_state_id,
        brand_id: vehicle_data.version.variation.brand_id,
        model_id: vehicle_data.version.variation.id,
        vtv_last_city_id: vehicle_data.vtv_last_city_id
          ? vehicle_data.vtv_last_city_id
          : "",
        plate_city_id: vehicle_data.plate_city_id
          ? vehicle_data.plate_city_id
          : "",
        plate_province_id: plate_province_id,
        vtv_province_id: vtv_province_id,
        owner_contact_id: vehicle_data.owner_contact_id,
        leasing_contact_id: vehicle_data.leasing_contact_id,
        leasing_duedate: vehicle_data.leasing_duedate,
        pledge_contact_id: vehicle_data.pledge_contact_id,
        description: vehicle_data.description ? vehicle_data.description : "",
        version: vehicle_data.version,
        variantion: vehicle_data.version.variation,
        infoauto_price_date: vehicle_data.infoauto_price_date,
        infoauto_price: vehicle_data.infoauto_price,
        sap_project_id: vehicle_data.sap_project_id
      },
      expirations: {
        fire_extinguisher_due_date: vehicle_data.fire_extinguisher_due_date,
        vtv_due_date: vehicle_data.vtv_due_date,
        cardoc_due_date: vehicle_data.cardoc_due_date,
        vtv_km_expiration: vehicle_data.vtv_km_expiration,
        rto_due_date: vehicle_data.rto_due_date
          ? vehicle_data.rto_due_date
          : "",
        vtv_last_city_id: vehicle_data.vtv_last_city_id
          ? vehicle_data.vtv_last_city_id
          : "",
        vtv_last_date: vehicle_data.vtv_last_date,
        vtv_province_id: vtv_province_id,
        last_mailing_date: vehicle_data.last_mailing_date,
        last_mailing_email: vehicle_data.last_mailing_email,
        send_expiration_mailing:
          vehicle_data.send_expiration_mailing === 1 ||
          vehicle_data.send_expiration_mailing === "1"
            ? 1
            : 0,
        mailing_day: vehicle_data.mailing_day ? vehicle_data.mailing_day : "",
        last_mailing_status: vehicle_data.last_mailing_status
          ? vehicle_data.last_mailing_status
          : ""
      },
      warranty: {
        warranty_up_to_km: vehicle_data.warranty_up_to_km,
        warranty_up_to_date: vehicle_data.warranty_up_to_date,
        warranty_state: vehicle_data.warranty_state
      },
      service: {
        service_last_date: vehicle_data.service_last_date,
        service_last_km: vehicle_data.service_last_km,
        service_origin: "EFLEET",
        maintenance_plan_id: vehicle_data.maintenance_plan_id,
        service_last_task_name: vehicle_data.service_last_task
          ? vehicle_data.service_last_task.name
          : ""
      },
      client_data: {
        client_structure_id: vehicle_data.client_structure_id,
        category_client: vehicle_data.category_client,
        group_category_client: vehicle_data.group_category_client,
        has_circulation_documents: vehicle_data.has_circulation_documents,
        contract_id: vehicle_data.contract_id,
        authorization_matrix_id: vehicle_data.authorization_matrix_id,
        policy_id: vehicle_data.policy_id,
        hansa_start_date: this.formatDate(vehicle_data.hansa_start_date),
        hansa_end_date: this.formatDate(vehicle_data.hansa_end_date)
      },
      equipment: {
        gps_ammount: vehicle_data.gps_ammount,
        gps_vehicle_number: vehicle_data.gps_vehicle_number,
        gps_detail: vehicle_data.gps_detail,
        gps_is_visible: vehicle_data.gps_is_visible,
        duplicated_key_date: vehicle_data.duplicated_key_date,
        has_duplicated_key: vehicle_data.has_duplicated_key,
        stereo_code: vehicle_data.stereo_code,
        vehicle_equipment_type_ids: equipments,
        fuel_provider: vehicle_data.fuel_provider,
        fuel_card_number: vehicle_data.fuel_card_number,
        toll_card_number: vehicle_data.toll_card_number,
        gps_provider_id: vehicle_data.gps_provider_id
      },
      insurance: {
        insurance_id: vehicle_data.insurance_id,
        insurance_ammount: vehicle_data.insurance_ammount
          ? vehicle_data.insurance_ammount
          : "",
        insurance_start_date: vehicle_data.insurance_start_date
          ? vehicle_data.insurance_start_date
          : ""
      },
      insurance_history: vehicle_data.insurance_history
        ? vehicle_data.insurance_history
        : [],
      preferences: { provider_ids: providers },
      not_preferences: { provider_ids: providers_not_prefered },
      addresses: { address_ids: addresses },
      related_contact: { subcontact_ids: related_contacts },
      financial_sales: {
        pledgde_closure_date: vehicle_data.pledgde_closure_date,
        pledgde_duedate: vehicle_data.pledgde_duedate,
        pledgde_number: vehicle_data.pledgde_number,
        buyer_purchase_date: vehicle_data.buyer_purchase_date,
        buyer_transfer_date: vehicle_data.buyer_transfer_date,
        buyer_contact_id: vehicle_data.buyer_contact_id
      },
      cities: cities,
      vtv_cities: vtv_cities,
      contract: vehicle_data.contract,
      vehicle_state: vehicle_state,
      active_booking: vehicle_data.active_booking,
      comments: vehicle_data.comments,
      media: vehicle_data.media.filter(
        m => m.collection_name !== "documentacion"
      ),
      wallet: vehicle_data.media.filter(
        m => m.collection_name === "documentacion"
      )
    });
    var authorization_matrices = this.refreshMatricesPolicies(
      vehicle_data.contract_id
    )[0];
    var policies = this.refreshMatricesPolicies(vehicle_data.contract_id)[1];
    this.setState({
      authorization_matrices: authorization_matrices,
      policies: policies
    });
  }

  formatDate(date) {
    //hansa_start_date = '2019-12-31'
    //return newDate[2]
    if (date == null || date === "") {
      return null;
    } else {
      if (date.includes("-")) {
        var dateParts = date.split("-");
        var day = dateParts[2];
        var month = parseInt(dateParts[1]);
        month = month < 10 ? "0" + month : month;
        var year = dateParts[0];
        return year + "-" + month + "-" + day;
      } else {
        var dateParts = date.split("/");
        var year = dateParts[2];
        var month = parseInt(dateParts[1]);
        month = month < 10 ? "0" + month : month;
        var day = dateParts[0];
        return year + "-" + month + "-" + day;
      }
    }
  }

  handleUpload(files) {
    this.setState({
      files: files
    });
  }

  handleWalletUpload(files) {
    this.setState({
      wallet_files: files
    });
  }

  addNewItem(mod) {
    var state = this.state;
    switch (mod) {
      case "provider_ids":
        state.preferences.provider_ids.push({ provider_id: "" });
        break;
      case "provider_ids_not_preferences":
        state.not_preferences.provider_ids.push({ provider_id: "" });
        break;
      case "vehicle_equipment_type_ids":
        state.equipment.vehicle_equipment_type_ids.push({
          vehicle_equipment_type_id: ""
        });
        break;
      case "address_ids":
        state.addresses.address_ids.push({ address_id: "" });
      case "subcontact_ids":
        state.related_contact.subcontact_ids.push({
          subcontact_id: "",
          relation_type_id: "",
          start_date: new Date().toISOString().slice(0, 10),
          end_date: "",
          has_car_doc_documents: ""
        });

        break;
    }
    this.setState({ state });
  }

  removeItem(mod, id) {
    var state = this.state;
    switch (mod) {
      case "provider_ids":
        state.items_to_delete.providers.preferred.push(
          state.preferences.provider_ids[id]
        );
        state.preferences.provider_ids = state.preferences.provider_ids.filter(
          (s, sidx) => id !== sidx
        );
        break;
      case "provider_ids_not_preferences":
        state.items_to_delete.providers.not_preferenced.push(
          state.not_preferences.provider_ids[id]
        );
        state.not_preferences.provider_ids = state.not_preferences.provider_ids.filter(
          (s, sidx) => id !== sidx
        );
        break;
      case "vehicle_equipment_type_ids":
        state.items_to_delete.vehicle_equipment_types.push(
          state.equipment.vehicle_equipment_type_ids[id]
        );
        state.equipment.vehicle_equipment_type_ids = state.equipment.vehicle_equipment_type_ids.filter(
          (s, sidx) => id !== sidx
        );
        break;
      case "address_ids":
        state.items_to_delete.addresses.push(state.addresses.address_ids[id]);
        state.addresses.address_ids = state.addresses.address_ids.filter(
          (s, sidx) => id !== sidx
        );
        break;
      case "subcontact_ids":
        state.items_to_delete.subcontacts.push(
          state.related_contact.subcontact_ids[id]
        );
        state.related_contact.subcontact_ids = state.related_contact.subcontact_ids.filter(
          (s, sidx) => id !== sidx
        );
        break;
    }
    this.setState({ state });
  }

  async refreshModels(brand_id) {
    var brand = await this.getBrand(brand_id);

    /*		this.state.brands.map((val, idx)=>{
		  if (parseInt(val.id) === parseInt(brand_id)){
		    val.variations.map((val2, idx2)=>{
		      models.push(val2)
		    })
		  }      
		})
*/
    return brand[0].variations;
  }

  refreshVersions(model_id) {
    var versions = [];
    this.state.models.map((val, idx) => {
      if (parseInt(val.id) === parseInt(model_id)) {
        val.versions.map((val2, idx2) => {
          versions.push(val2);
        });
      }
    });
    return versions;
  }

  refreshMatricesPolicies(contract_id) {
    var authorization_matrices = [];
    var policies = [];
    this.state.contracts.map((val, idx) => {
      if (parseInt(val.id) === parseInt(contract_id)) {
        val.authorization_matrixes.map((val2, idx2) => {
          authorization_matrices.push(val2);
        });
        val.policies.map((val2, idx2) => {
          policies.push(val2);
        });
      }
    });
    return [authorization_matrices, policies];
  }

  async getClientByContract(contract_id) {
    var client_id = "";
    this.state.contracts.map((val, idx) => {
      if (parseInt(val.id) === parseInt(contract_id)) {
        client_id = val.contact_id;
      }
    });
    return client_id;
  }
  async getClient(client_id) {
    this.setState({ loading: true });

    if (client_id !== null) {
      const token = localStorage.getItem("userToken");
      var results = await axios
        .all([
          axios.get(api.subcontacts().all(client_id), {
            headers: { Authorization: `Bearer ${token}` }
          }),
          axios.get(api.contacts().get(client_id), {
            headers: { Authorization: `Bearer ${token}` }
          }),
          axios.get(api.contacts().addresses(client_id), {
            headers: { Authorization: `Bearer ${token}` }
          })
        ])
        .then(
          axios.spread((...responses) => {
            const subcontacts = responses[0].data;
            const client_structures =
              responses[1].data.client.structure.length !== 0
                ? responses[1].data.client.structure
                : [];
            const contact_addresses = responses[2].data;
            this.setState({
              subcontacts,
              client_structures,
              contact_addresses
            });
          })
        );
    }
    return true;
  }

  handleChange = async (event, mod) => {
    var key = event.target.name;
    var val = event.target.value;
    var state = this.state;
    switch (mod) {
      case "basic_data":
        state.basic_data[key] = val;
        if (key === "plate_province_id") {
          state.cities = await this.getCities(val);
        }
        if (key === "brand_id") {
          state.models = await this.refreshModels(val);
          state.versions = [];
        }
        if (key === "model_id") {
          state.versions = this.refreshVersions(val);
        }

        if (key === "last_km" || key === "plate_date") {
          if (this.state.basic_data.version_id) {
            var version = this.state.versions.filter(
              version =>
                parseInt(version.id) ===
                parseInt(this.state.basic_data.version_id)
            );
            if (version) {
              version = version[0];
              if (version.default_km_warranty > 0) {
                state.warranty.warranty_up_to_km = version.default_km_warranty;
              }
              if (
                version.default_months_warranty > 0 &&
                this.state.basic_data.plate_date !== ""
              ) {
                var warranty_up_to_date = new Date(
                  this.state.basic_data.plate_date
                );
                warranty_up_to_date.setMonth(
                  warranty_up_to_date.getMonth() +
                    version.default_months_warranty
                );
                let year = warranty_up_to_date.getFullYear();
                let month = warranty_up_to_date.getMonth() + 1;
                month = month < 10 ? "0" + month : month;
                let day =
                  warranty_up_to_date.getDate() < 10
                    ? "0" + warranty_up_to_date.getDate()
                    : warranty_up_to_date.getDate();
                state.warranty.warranty_up_to_date =
                  year + "-" + month + "-" + day;
              }
            }
          }
        }
        if (key === "vehicle_state_id") {
          var vehicle_state = this.state.vehicle_states.filter(
            state => parseInt(state.id) === parseInt(val)
          );
          if (vehicle_state) {
            state.vehicle_state = vehicle_state[0];
            if (
              vehicle_state[0] &&
              vehicle_state[0].name === "BAJA GESTION FLOTAS"
            ) {
              state.client_data.hansa_end_date = new Date()
                .toISOString()
                .slice(0, 10);
            }
            if (vehicle_state[0].name === "ACTIVO GESTION FLOTAS") {
              state.client_data.hansa_end_date = "";
            }
          }
        }
        if (key === "is_fleet_owner") {
          state.basic_data.vehicle_state_id = "";
        }
        if (key === "is_fleet_owner" && parseInt(val) === 1) {
          state.client_data.policy_id = "";
          state.client_data.authorization_matrix_id = "";
          if (this.state.policies_ac.length === 1) {
            state.client_data.policy_id = this.state.policies_ac[0].id;
          }
          if (this.state.authorization_matrices_ac.length === 1) {
            state.client_data.authorization_matrix_id = this.state.authorization_matrices_ac[0].id;
          }
        }

        if (key === "owner_contact_id") {
          state.client_data.contract_id = "";
          var contract = this.state.contracts.filter(
            contract => parseInt(contract.contact_id) === parseInt(val)
          );
          if (contract) {
            contract = contract[0];
            state.client_data.contract_id = contract.id;
            state.client_data.contract = contract;
            state.authorization_matrices = this.refreshMatricesPolicies(
              contract.id
            )[0];
            state.policies = this.refreshMatricesPolicies(contract.id)[1];
            if (state.policies.length === 1) {
              state.client_data.policy_id = state.policies[0].id;
            }
            if (state.authorization_matrices.length === 1) {
              state.client_data.authorization_matrix_id =
                state.authorization_matrices[0].id;
            }
            var client_id = await this.getClientByContract(contract.id);
            var result = this.getClient(client_id);
          }
        }
        break;
      case "expirations":
        if (key === "vtv_province_id") {
          state.vtv_cities = await this.getCities(val);
        }
        state.expirations[key] = val;
        break;
      case "warranty":
        state.warranty[key] = val;
        break;
      case "client_data":
        state.client_data[key] = val;
        if (key === "contract_id") {
          state.client_data.authorization_matrix_id = "";
          state.client_data.policy_id = "";
          state.authorization_matrices = this.refreshMatricesPolicies(val)[0];
          state.policies = this.refreshMatricesPolicies(val)[1];
          if (state.policies.length === 1) {
            state.client_data.policy_id = state.policies[0].id;
          }
          if (state.authorization_matrices.length === 1) {
            state.client_data.authorization_matrix_id =
              state.authorization_matrices[0].id;
          }
          var client_id = await this.getClientByContract(val);
          var result = this.getClient(client_id);
          var contract = this.state.contracts.filter(
            contract => parseInt(contract.id) === parseInt(val)
          );
          state.client_data.contract = contract[0];
        }
        break;
      case "insurance":
        if (key === "insurance_ammount") {
          val = val.replace("$", "").replace(/\,/g, "");
        }
        state.insurance[key] = val;
        break;
      case "related_contact":
        var res = event.target.name.split(".");
        key = res[0];
        var id = res[1];
        if (key === "relation_type_id") {
          state.related_contact.subcontact_ids[id].relation_type_id = val;
          if (parseInt(val) === 2) {
            state.related_contact.subcontact_ids.map(item => {
              if (item.subcontact_id > 0) {
                if (!item.end_date || item.end_date === "") {
                  item.end_date = new Date().toISOString().slice(0, 10);
                  return item;
                }
              }
            });
          }
        } else if (key === "start_date") {
          state.related_contact.subcontact_ids[id].start_date = val;
        } else if (key === "end_date") {
          state.related_contact.subcontact_ids[id].end_date = val;
        } else if (key === "has_car_doc_documents") {
          state.related_contact.subcontact_ids[id].has_car_doc_documents = val;
        } else if (key === "subcontact_id") {
          state.related_contact.subcontact_ids[id].subcontact_id = val;
        } else if (key === "car_doc_documents_due_date") {
          state.related_contact.subcontact_ids[
            id
          ].car_doc_documents_due_date = val;
        } else if (key === "car_doc_document_number") {
          state.related_contact.subcontact_ids[
            id
          ].car_doc_document_number = val;
        }
        break;
      case "equipment":
        var res = event.target.name.split(".");
        key = res[0];
        var id = res[1];
        if (key === "vehicle_equipment_type_id") {
          state.equipment.vehicle_equipment_type_ids[
            id
          ].vehicle_equipment_type_id = val;
        } else {
          state.equipment[key] = val;
        }
        break;
      case "service":
        state.service[key] = val;
        break;
      case "addresses":
        var res = event.target.name.split(".");
        key = res[0];
        var id = res[1];
        if (key === "address_id") {
          state.addresses.address_ids[id].address_id = val;
        }
        break;
      case "preferences":
        var res = event.target.name.split(".");
        key = res[0];
        var id = res[1];
        if (key === "provider_id") {
          //			    	id = id.replace('-option-0','').split('.')
          id = id.substring(0, id.indexOf("-"));
          state.preferences.provider_ids[id].provider_id = val;
          var data = await this.getProviderData(val);
          state.preferences.provider_ids[id].business_name =
            data.business_name + " - " + data.fantasy_name;
        } else {
          state.preferences[key] = val;
        }
        state.preferences.provider_ids.push({ provider_id: "" });
        break;
      case "not_preferences":
        var res = event.target.name.split(".");
        key = res[0];
        var id = res[1];
        if (key === "provider_id") {
          id = id.substring(0, id.indexOf("-"));
          state.not_preferences.provider_ids[id].provider_id = val;
          var data = await this.getProviderData(val);
          state.not_preferences.provider_ids[id].business_name =
            data.business_name + " - " + data.fantasy_name;
        } else {
          state.not_preferences[key] = val;
        }
        state.not_preferences.provider_ids.push({ provider_id: "" });
      case "tiers":
        if (event.target.name !== "tiers_to_show") {
          var res = event.target.name.split(".");
          key = res[1];
          var id = res[0];
          state.tiers_data.tiers.map((tier, idx) => {
            if (parseInt(tier.tier_type_id) === parseInt(id)) {
              if (key === "rotate_id") {
                var tier_type_id_tmp = tier.tier_type_id;
                var tier_tmp = state.tiers_data.tiers.filter(
                  t => parseInt(t.tier_type_id) === parseInt(val)
                );
                var tier_tmp_index = state.tiers_data.tiers.findIndex(t => {
                  return parseInt(t.tier_type_id) === parseInt(val);
                });
                state.tiers_data.tiers[tier_tmp_index] =
                  state.tiers_data.tiers[idx];
                state.tiers_data.tiers[tier_tmp_index]["tier_type_id"] = val;
                state.tiers_data.tiers[idx] = tier_tmp[0];
                state.tiers_data.tiers[idx]["tier_type_id"] = tier_type_id_tmp;
              } else {
                state.tiers_data.tiers[idx][key] = val;
              }
            }
          });
        } else {
          state.tiers_data.tiers_to_show = val;
        }
        break;
      case "financial_sales":
        var res = event.target.name.split("-");
        key = res[0];
        var id = res[1];
        if (key === "buyer_contact_id") {
          key = "buyer_contact_id"; //key.replace('-option-0','').split('.')
        }
        state.financial_sales[key] = val;
        break;
      case "purchase":
        if (
          key.includes("contact_id") ||
          event.target.name.includes("contact_id")
        ) {
          key = "contact_id"; //key.replace('-option-0','').split('.')
        }

        if (key === "price_list" || key === "price_buy") {
          val = val.replace("$", "");
        }
        state.purchase[key] = val;
        break;
      case "sales_data":
        console.log("sales_data!", event.target.name, key, val);
        if (
          key.includes("buyer_id") ||
          event.target.name.includes("buyer_id")
        ) {
          key = "buyer_id";
        }
        if (
          key.includes("reseller_id") ||
          event.target.name.includes("reseller_id")
        ) {
          key = "reseller_id";
        }

        if (key === "resale_price" || key === "buyer_price") {
          val = val.replace("$", "").replace(/\,/g, "");
        }
        state.sales_data[key] = val;
        break;
      case "comments":
        key = key.replace("_comment", "");
        var comment = state.comments.filter(c => c.field_name === key);
        if (comment[0]) {
          var index = state.comments.findIndex(p => p.field_name === key);
          console.log("index!", index);
          state.comments[index]["comment"] = val;
        } else {
          state.comments.push({ field_name: key, comment: val });
        }

        break;
    }
    if (!state.providers) state.providers = {};
    state.providers.options = [];
    this.setState({ state, loading: false });
  };

  getProviderData = id => {
    if (id !== "" && id !== undefined && id !== null) {
      var data = {};
      this.state.providers.options.map((val, idx) => {
        if (parseInt(val.id) === parseInt(id)) {
          data.business_name = val.business_name;
          data.fantasy_name = val.fantasy_name;
        }
      });
    }

    return data;
  };

  onMediaRefresh = async () => {
    console.log("onMediaRefresh");
    var basic_data = this.state.basic_data;
    var vehicle_data = await this.getVehicle(basic_data.id);
    vehicle_data = vehicle_data[0];
    var wallet = vehicle_data.media.filter(
      m => m.collection_name === "documentacion"
    );
    var media = vehicle_data.media.filter(
      m => m.collection_name === "documentacion"
    );
    this.setState({ media: media, wallet: wallet });
  };

  handleSubmit = event => {
    this.setState({ backdrop: true });
    event.preventDefault();
    event.stopPropagation();
    this.setState({ errors: "" });
    const steps = [
      "Vehículo",
      "Vencimientos/Garantía/Service",
      "Cliente",
      "Seguro",
      "Ubicación",
      "Cubiertas",
      "Financiero/Venta",
      "Datos Compra",
      "Otros"
    ];
    var client_validations = this.handleValidations("Cliente");
    var step_validations = this.handleValidations(steps[this.state.activeStep]);
    if (client_validations !== true || step_validations !== true) {
      var message = !client_validations
        ? "Hay errores en la solapa de Cliente. Por favor revisar"
        : "Hay errores en la carga de la solapa actual. Por favor revisar";
      this.setState({
        dialogOpen: true,
        message: message,
        errors: true
      });
      this.setState({ backdrop: false });
      return;
    }
    var formData = new FormData();

    /* basic_data */

    formData.set("vehicle[plate]", this.state.basic_data.plate.toUpperCase());
    formData.set(
      "vehicle[code]",
      this.state.basic_data.code ? this.state.basic_data.code : ""
    );
    formData.set(
      "vehicle[color]",
      this.state.basic_data.color ? this.state.basic_data.color : ""
    );
    formData.set(
      "vehicle[chassis]",
      this.state.basic_data.chassis ? this.state.basic_data.chassis : ""
    );
    formData.set(
      "vehicle[motor_number]",
      this.state.basic_data.motor_number
        ? this.state.basic_data.motor_number
        : ""
    );
    formData.set(
      "vehicle[year]",
      this.state.basic_data.year ? this.state.basic_data.year : ""
    );
    formData.set(
      "vehicle[plate_date]",
      this.state.basic_data.plate_date ? this.state.basic_data.plate_date : ""
    );
    formData.set(
      "vehicle[vtv_last_date]",
      this.state.expirations.vtv_last_date
        ? this.state.expirations.vtv_last_date
        : ""
    );
    formData.set(
      "vehicle[is_fleet_owner]",
      this.state.basic_data.is_fleet_owner
        ? this.state.basic_data.is_fleet_owner
        : 0
    );
    formData.set(
      "vehicle[is_owner]",
      this.state.basic_data.is_owner ? this.state.basic_data.is_owner : ""
    );
    formData.set(
      "vehicle[owner_contact_id]",
      this.state.basic_data.owner_contact_id
        ? this.state.basic_data.owner_contact_id
        : ""
    );
    formData.set(
      "vehicle[last_km]",
      this.state.basic_data.last_km ? this.state.basic_data.last_km : ""
    );
    formData.set("vehicle[last_km_origin]", "EFLEET");
    formData.set(
      "vehicle[last_km_date]",
      this.state.basic_data.last_km_date
        ? this.state.basic_data.last_km_date
        : ""
    );
    formData.set(
      "vehicle[condition_type]",
      this.state.basic_data.condition_type
        ? this.state.basic_data.condition_type
        : ""
    );
    formData.set(
      "vehicle[version_id]",
      this.state.basic_data.version_id ? this.state.basic_data.version_id : ""
    );
    formData.set(
      "vehicle[vehicle_state_id]",
      this.state.basic_data.vehicle_state_id
        ? this.state.basic_data.vehicle_state_id
        : "1"
    );
    formData.set(
      "vehicle[leasing_duedate]",
      this.state.basic_data.leasing_duedate
        ? this.state.basic_data.leasing_duedate
        : ""
    );
    //	    formData.set("vehicle[leasing_owner]", (this.state.basic_data.leasing_owner) ? this.state.basic_data.leasing_owner :'');
    formData.set(
      "vehicle[leasing_contact_id]",
      this.state.basic_data.leasing_contact_id
        ? this.state.basic_data.leasing_contact_id
        : ""
    );

    if (this.state.expirations.vtv_last_city_id !== "") {
      formData.set(
        "vehicle[vtv_last_city_id]",
        this.state.expirations.vtv_last_city_id
      );
    }
    if (this.state.basic_data.plate_city_id !== "") {
      formData.set(
        "vehicle[plate_city_id]",
        this.state.basic_data.plate_city_id
      );
    }

    /* expirations */

    formData.set(
      "vehicle[send_expiration_mailing]",
      this.state.expirations.send_expiration_mailing
        ? this.state.expirations.send_expiration_mailing
        : false
    );
    formData.set(
      "vehicle[mailing_day]",
      this.state.expirations.mailing_day
        ? this.state.expirations.mailing_day
        : ""
    );
    formData.set(
      "vehicle[fire_extinguisher_due_date]",
      this.state.expirations.fire_extinguisher_due_date
        ? this.state.expirations.fire_extinguisher_due_date
        : ""
    );
    formData.set(
      "vehicle[vtv_due_date]",
      this.state.expirations.vtv_due_date
        ? this.state.expirations.vtv_due_date
        : ""
    );
    formData.set(
      "vehicle[vtv_km_expiration]",
      this.state.expirations.vtv_km_expiration
        ? this.state.expirations.vtv_km_expiration
        : ""
    );
    formData.set(
      "vehicle[rto_due_date]",
      this.state.expirations.rto_due_date
        ? this.state.expirations.rto_due_date
        : ""
    );
    formData.set(
      "vehicle[cardoc_due_date]",
      this.state.expirations.cardoc_due_date
        ? this.state.expirations.cardoc_due_date
        : ""
    );

    /* warranty */

    formData.set(
      "vehicle[warranty_up_to_km]",
      this.state.warranty.warranty_up_to_km
        ? this.state.warranty.warranty_up_to_km
        : ""
    );
    formData.set(
      "vehicle[warranty_up_to_date]",
      this.state.warranty.warranty_up_to_date
        ? this.state.warranty.warranty_up_to_date
        : ""
    );
    formData.set(
      "vehicle[warranty_state]",
      this.state.warranty.warranty_state
        ? this.state.warranty.warranty_state
        : "0"
    );

    /* service */

    formData.set(
      "vehicle[service_last_km]",
      this.state.service.service_last_km
        ? this.state.service.service_last_km
        : ""
    );
    formData.set("vehicle[service_origin]", "EFLEET");
    formData.set(
      "vehicle[service_last_date]",
      this.state.service.service_last_date
        ? this.state.service.service_last_date
        : ""
    );
    formData.set(
      "vehicle[maintenance_plan_id]",
      this.state.service.maintenance_plan_id
        ? this.state.service.maintenance_plan_id
        : ""
    );

    /* client_data */
    formData.set(
      "vehicle[client_structure_id]",
      this.state.client_data.client_structure_id
        ? this.state.client_data.client_structure_id
        : ""
    );
    formData.set(
      "vehicle[category_client]",
      this.state.client_data.category_client
        ? this.state.client_data.category_client
        : ""
    );
    formData.set(
      "vehicle[group_category_client]",
      this.state.client_data.group_category_client
        ? this.state.client_data.group_category_client
        : ""
    );
    formData.set(
      "vehicle[has_circulation_documents]",
      this.state.client_data.has_circulation_documents
        ? this.state.client_data.has_circulation_documents
        : "0"
    );
    formData.set(
      "vehicle[contract_id]",
      this.state.client_data.contract_id
        ? this.state.client_data.contract_id
        : ""
    );
    formData.set(
      "vehicle[sap_project_id]",
      this.state.basic_data.sap_project_id
        ? this.state.basic_data.sap_project_id
        : ""
    );

    formData.set(
      "vehicle[authorization_matrix_id]",
      this.state.client_data.authorization_matrix_id
        ? this.state.client_data.authorization_matrix_id
        : ""
    );
    formData.set(
      "vehicle[policy_id]",
      this.state.client_data.policy_id ? this.state.client_data.policy_id : ""
    );
    formData.set(
      "vehicle[hansa_start_date]",
      this.state.client_data.hansa_start_date
        ? this.state.client_data.hansa_start_date
        : ""
    );
    formData.set(
      "vehicle[hansa_end_date]",
      this.state.client_data.hansa_end_date
        ? this.state.client_data.hansa_end_date
        : ""
    );

    /* equipment && insurance &&  preferences */
    formData.set(
      "vehicle[fuel_provider]",
      this.state.equipment.fuel_provider
        ? this.state.equipment.fuel_provider
        : ""
    );
    formData.set(
      "vehicle[fuel_card_number]",
      this.state.equipment.fuel_card_number
        ? this.state.equipment.fuel_card_number
        : ""
    );
    formData.set(
      "vehicle[toll_card_number]",
      this.state.equipment.toll_card_number
        ? this.state.equipment.toll_card_number
        : ""
    );
    formData.set(
      "vehicle[stereo_code]",
      this.state.equipment.stereo_code ? this.state.equipment.stereo_code : ""
    );
    formData.set(
      "vehicle[gps_provider_id]",
      this.state.equipment.gps_provider_id
        ? this.state.equipment.gps_provider_id
        : 1
    );
    formData.set(
      "vehicle[gps_ammount]",
      this.state.equipment.gps_ammount ? this.state.equipment.gps_ammount : ""
    );
    formData.set(
      "vehicle[gps_vehicle_number]",
      this.state.equipment.gps_vehicle_number
        ? this.state.equipment.gps_vehicle_number
        : ""
    );
    formData.set(
      "vehicle[gps_detail]",
      this.state.equipment.gps_detail ? this.state.equipment.gps_detail : ""
    );
    formData.set(
      "vehicle[gps_is_visible]",
      this.state.equipment.gps_is_visible
        ? this.state.equipment.gps_is_visible
        : 0
    );

    formData.set(
      "vehicle[duplicated_key_date]",
      this.state.equipment.duplicated_key_date
        ? this.state.equipment.duplicated_key_date
        : ""
    );
    formData.set(
      "vehicle[has_duplicated_key]",
      this.state.equipment.has_duplicated_key
        ? this.state.equipment.has_duplicated_key
        : 0
    );

    formData.set(
      "vehicle[insurance_ammount]",
      this.state.insurance.insurance_ammount
        ? this.state.insurance.insurance_ammount
        : ""
    );
    formData.set(
      "vehicle[insurance_id]",
      this.state.insurance.insurance_id ? this.state.insurance.insurance_id : ""
    );
    formData.set(
      "vehicle[insurance_start_date]",
      this.state.insurance.insurance_start_date
        ? this.state.insurance.insurance_start_date
        : ""
    );

    /* financial sales */

    formData.set(
      "vehicle[pledge_contact_id]",
      this.state.basic_data.pledge_contact_id
        ? this.state.basic_data.pledge_contact_id
        : ""
    );
    formData.set(
      "vehicle[pledgde_duedate]",
      this.state.financial_sales.pledgde_duedate
        ? this.state.financial_sales.pledgde_duedate
        : ""
    );
    formData.set(
      "vehicle[pledgde_closure_date]",
      this.state.financial_sales.pledgde_closure_date
        ? this.state.financial_sales.pledgde_closure_date
        : ""
    );
    formData.set(
      "vehicle[pledgde_number]",
      this.state.financial_sales.pledgde_number
        ? this.state.financial_sales.pledgde_number
        : ""
    );
    formData.set(
      "vehicle[buyer_contact_id]",
      this.state.financial_sales.buyer_contact_id
        ? this.state.financial_sales.buyer_contact_id
        : ""
    );
    formData.set(
      "vehicle[buyer_purchase_date]",
      this.state.financial_sales.buyer_purchase_date
        ? this.state.financial_sales.buyer_purchase_date
        : ""
    );
    formData.set(
      "vehicle[buyer_transfer_date]",
      this.state.financial_sales.buyer_transfer_date
        ? this.state.financial_sales.buyer_transfer_date
        : ""
    );

    /* purchase */
    formData.set(
      "vehicle_purchase[request_date]",
      this.state.purchase.request_date ? this.state.purchase.request_date : ""
    );
    formData.set(
      "vehicle_purchase[estimated_invoice_date]",
      this.state.purchase.estimated_invoice_date
        ? this.state.purchase.estimated_invoice_date
        : ""
    );
    formData.set(
      "vehicle_purchase[invoice_reception_date]",
      this.state.purchase.invoice_reception_date
        ? this.state.purchase.invoice_reception_date
        : ""
    );
    formData.set(
      "vehicle_purchase[invoice_date]",
      this.state.purchase.invoice_date ? this.state.purchase.invoice_date : ""
    );
    formData.set(
      "vehicle_purchase[estimated_plate_date]",
      this.state.purchase.estimated_plate_date
        ? this.state.purchase.estimated_plate_date
        : ""
    );
    formData.set(
      "vehicle_purchase[payment_date]",
      this.state.purchase.payment_date ? this.state.purchase.payment_date : ""
    );
    formData.set(
      "vehicle_purchase[documents_reception_date]",
      this.state.purchase.documents_reception_date
        ? this.state.purchase.documents_reception_date
        : ""
    );
    formData.set(
      "vehicle_purchase[plate_delivered_date]",
      this.state.purchase.plate_delivered_date
        ? this.state.purchase.plate_delivered_date
        : ""
    );
    formData.set(
      "vehicle_purchase[no_usage]",
      this.state.purchase.no_usage ? 1 : 0
    );
    formData.set(
      "vehicle_purchase[vehicle_delivered_date]",
      this.state.purchase.vehicle_delivered_date
        ? this.state.purchase.vehicle_delivered_date
        : ""
    );
    formData.set(
      "vehicle_purchase[estimated_vehicle_delivered_date]",
      this.state.purchase.estimated_vehicle_delivered_date
        ? this.state.purchase.estimated_vehicle_delivered_date
        : ""
    );
    formData.set(
      "vehicle_purchase[invoice_province_id]",
      this.state.purchase.invoice_province_id
        ? this.state.purchase.invoice_province_id
        : ""
    );
    formData.set(
      "vehicle_purchase[invoice_number]",
      this.state.purchase.invoice_number
        ? this.state.purchase.invoice_number
        : ""
    );
    formData.set(
      "vehicle_purchase[due_date]",
      this.state.purchase.due_date ? this.state.purchase.due_date : ""
    );
    formData.set(
      "vehicle_purchase[carstore_name]",
      this.state.purchase.carstore_name ? this.state.purchase.carstore_name : ""
    );
    formData.set(
      "vehicle_purchase[price_list]",
      this.state.purchase.price_list ? this.state.purchase.price_list : ""
    );
    formData.set(
      "vehicle_purchase[price_buy]",
      this.state.purchase.price_buy ? this.state.purchase.price_buy : ""
    );
    formData.set(
      "vehicle_purchase[contact_id]",
      this.state.purchase.contact_id ? this.state.purchase.contact_id : ""
    );
    formData.set(
      "vehicle_purchase[destiny_client_id]",
      this.state.purchase.destiny_client_id
        ? this.state.purchase.destiny_client_id
        : ""
    );

    /* sales data */
    formData.set(
      "vehicle_sales_data[buyer_id]",
      this.state.sales_data.buyer_id ? this.state.sales_data.buyer_id : ""
    );
    formData.set(
      "vehicle_sales_data[reseller_id]",
      this.state.sales_data.reseller_id ? this.state.sales_data.reseller_id : ""
    );
    formData.set(
      "vehicle_sales_data[buyer_price]",
      this.state.sales_data.buyer_price ? this.state.sales_data.buyer_price : ""
    );
    formData.set(
      "vehicle_sales_data[resale_price]",
      this.state.sales_data.resale_price
        ? this.state.sales_data.resale_price
        : ""
    );
    formData.set(
      "vehicle_sales_data[buyer_payment_date]",
      this.state.sales_data.buyer_payment_date
        ? this.state.sales_data.buyer_payment_date
        : ""
    );
    formData.set(
      "vehicle_sales_data[reseller_payment_date]",
      this.state.sales_data.reseller_payment_date
        ? this.state.sales_data.reseller_payment_date
        : ""
    );
    formData.set(
      "vehicle_sales_data[buyer_sale_date]",
      this.state.sales_data.buyer_sale_date
        ? this.state.sales_data.buyer_sale_date
        : ""
    );
    formData.set(
      "vehicle_sales_data[reseller_delivery_date]",
      this.state.sales_data.reseller_delivery_date
        ? this.state.sales_data.reseller_delivery_date
        : ""
    );
    formData.set(
      "vehicle_sales_data[buyer_sale_km]",
      this.state.sales_data.buyer_sale_km
        ? this.state.sales_data.buyer_sale_km
        : ""
    );
    formData.set(
      "vehicle_sales_data[reseller_delivery_km]",
      this.state.sales_data.reseller_delivery_km
        ? this.state.sales_data.reseller_delivery_km
        : ""
    );
    formData.set(
      "vehicle_sales_data[has_completed_documentation]",
      this.state.sales_data.has_completed_documentation
        ? this.state.sales_data.has_completed_documentation
        : false
    );
    formData.set(
      "vehicle_sales_data[missing_documentation]",
      this.state.sales_data.missing_documentation
        ? this.state.sales_data.missing_documentation
        : ""
    );
    formData.set(
      "vehicle_sales_data[comments]",
      this.state.sales_data.comments ? this.state.sales_data.comments : ""
    );
    formData.set(
      "vehicle_sales_data[is_consignment]",
      this.state.sales_data.is_consignment
        ? this.state.sales_data.is_consignment
        : false
    );

    /* purchase comments */
    var comments_idx = 0;
    this.state.comments.map((val, idx) => {
      if (val.comment) {
        formData.set(
          "vehicle[comments][" + comments_idx + "][comment]",
          val.comment ? val.comment : ""
        );
        formData.set(
          "vehicle[comments][" + comments_idx + "][field_name]",
          val.field_name ? val.field_name : ""
        );
      }
      if (val.id) {
        formData.set(
          "vehicle[comments][" + comments_idx + "][id]",
          val.id ? val.id : ""
        );
      }
      comments_idx++;
    });

    /* extra */
    //formData.set("vehicle[description]", '');
    formData.set("vehicle[hansa_active]", 1);

    var tier_idx = 0;
    this.state.tiers_data.tiers.map((val, idx) => {
      if (val.tier_type_id !== "" && val.last_tier_variation_id !== "") {
        formData.set(
          "vehicle[tiers][" + tier_idx + "][last_tier_variation_id]",
          parseInt(val.last_tier_variation_id) !== 0
            ? val.last_tier_variation_id
            : ""
        );
        formData.set(
          "vehicle[tiers][" + tier_idx + "][tier_type_id]",
          val.tier_type_id
        );
        formData.set(
          "vehicle[tiers][" + tier_idx + "][last_km_change]",
          val.last_km_change || ""
        );
        formData.set(
          "vehicle[tiers][" + tier_idx + "][last_date_change]",
          val.last_date_change || ""
        );
        formData.set(
          "vehicle[tiers][" + tier_idx + "][next_date_change]",
          val.next_date_change || ""
        );
        formData.set(
          "vehicle[tiers][" + tier_idx + "][next_km_change]",
          val.next_km_change || ""
        );
        formData.set(
          "vehicle[tiers][" + tier_idx + "][tier_variation_wheel]",
          val.tier_variation_wheel || ""
        );
        formData.set(
          "vehicle[tiers][" + tier_idx + "][tier_variation_anchor]",
          val.tier_variation_anchor || ""
        );
        formData.set(
          "vehicle[tiers][" + tier_idx + "][tier_variation_size]",
          val.tier_variation_size || ""
        );
        formData.set(
          "vehicle[tiers][" + tier_idx + "][tier_variation_brand_id]",
          val.tier_variation_brand_id || ""
        );
        formData.set(
          "vehicle[tiers][" + tier_idx + "][tier_variation_name]",
          val.tier_variation_name || ""
        );
        tier_idx++;
      }
    });

    var vehicle_equipment_type_idx = 0;
    this.state.equipment.vehicle_equipment_type_ids.map((val, idx) => {
      if (val.vehicle_equipment_type_id !== "") {
        formData.set(
          "vehicle[equipments][" +
            vehicle_equipment_type_idx +
            "][vehicle_equipment_type_id]",
          val.vehicle_equipment_type_id
        );
        formData.set(
          "vehicle[equipments][" + vehicle_equipment_type_idx + "][name]",
          "1"
        );
        vehicle_equipment_type_idx++;
      }
    });

    var subcontact_idx = 0;
    this.state.related_contact.subcontact_ids.map((val, idx) => {
      if (val.subcontact_id !== "" && val.relation_type_id !== "") {
        formData.set(
          "vehicle[subcontacts][" + subcontact_idx + "][subcontact_id]",
          val.subcontact_id
        );
        formData.set(
          "vehicle[subcontacts][" + subcontact_idx + "][relation_type_id]",
          val.relation_type_id
        );
        formData.set(
          "vehicle[subcontacts][" + subcontact_idx + "][start_date]",
          val.start_date ? val.start_date : ""
        );
        formData.set(
          "vehicle[subcontacts][" + subcontact_idx + "][end_date]",
          val.end_date ? val.end_date : ""
        );
        formData.set(
          "vehicle[subcontacts][" + subcontact_idx + "][has_car_doc_documents]",
          val.has_car_doc_documents
        );
        formData.set(
          "vehicle[subcontacts][" +
            subcontact_idx +
            "][car_doc_documents_due_date]",
          val.car_doc_documents_due_date ? val.car_doc_documents_due_date : ""
        );
        formData.set(
          "vehicle[subcontacts][" +
            subcontact_idx +
            "][car_doc_document_number]",
          val.car_doc_document_number ? val.car_doc_document_number : ""
        );
        subcontact_idx++;
      }
    });

    var address_idx = 0;
    this.state.addresses.address_ids.map((val, idx) => {
      if (val.address_id !== "") {
        formData.set(
          "vehicle[addresses][" + address_idx + "][address_id]",
          val.address_id
        );
        address_idx++;
      }
    });
    var provider_idx = 0;
    this.state.preferences.provider_ids.map((val, idx) => {
      if (val.provider_id !== "") {
        formData.set(
          "vehicle[providers][" + provider_idx + "][provider_id]",
          val.provider_id
        );
        formData.set(
          "vehicle[providers][" + provider_idx + "][is_prefered]",
          1
        );
        provider_idx++;
      }
    });

    this.state.not_preferences.provider_ids.map((val, idx) => {
      if (val.provider_id !== "") {
        formData.set(
          "vehicle[providers][" + provider_idx + "][provider_id]",
          val.provider_id
        );
        formData.set(
          "vehicle[providers][" + provider_idx + "][is_prefered]",
          0
        );
        provider_idx++;
      }
    });

    this.state.items_to_delete.providers.preferred.map((val, idx) => {
      if (val.provider_id !== "" && this.state.vehicle_id) {
        formData.set(
          "vehicle[providers][" + provider_idx + "][provider_id]",
          val.provider_id
        );
        formData.set(
          "vehicle[providers][" + provider_idx + "][is_prefered]",
          0
        );
        formData.set(
          "vehicle[providers][" + provider_idx + "][deleted_at]",
          new Date()
            .toISOString()
            .slice(0, 19)
            .replace("T", " ")
        );
        provider_idx++;
      }
    });

    this.state.items_to_delete.providers.not_preferenced.map((val, idx) => {
      if (val.provider_id !== "" && this.state.vehicle_id) {
        formData.set(
          "vehicle[providers][" + provider_idx + "][provider_id]",
          val.provider_id
        );
        formData.set(
          "vehicle[providers][" + provider_idx + "][is_prefered]",
          0
        );
        formData.set(
          "vehicle[providers][" + provider_idx + "][deleted_at]",
          new Date()
            .toISOString()
            .slice(0, 19)
            .replace("T", " ")
        );
        provider_idx++;
      }
    });

    this.state.items_to_delete.addresses.map((val, idx) => {
      if (val.address_id !== "" && this.state.vehicle_id) {
        formData.set(
          "vehicle[addresses][" + address_idx + "][address_id]",
          val.address_id
        );
        formData.set(
          "vehicle[addresses][" + address_idx + "][deleted_at]",
          new Date()
            .toISOString()
            .slice(0, 19)
            .replace("T", " ")
        );
        address_idx++;
      }
    });

    this.state.items_to_delete.vehicle_equipment_types.map((val, idx) => {
      if (val.vehicle_equipment_type_id !== "" && this.state.vehicle_id) {
        formData.set(
          "vehicle[equipments][" +
            vehicle_equipment_type_idx +
            "][vehicle_equipment_type_id]",
          val.vehicle_equipment_type_id
        );
        formData.set(
          "vehicle[equipments][" + vehicle_equipment_type_idx + "][name]",
          "1"
        );
        formData.set(
          "vehicle[equipments][" + vehicle_equipment_type_idx + "][deleted_at]",
          new Date()
            .toISOString()
            .slice(0, 19)
            .replace("T", " ")
        );
        vehicle_equipment_type_idx++;
      }
    });

    this.state.items_to_delete.subcontacts.map((val, idx) => {
      if (
        val.subcontact_id !== "" &&
        val.relation_type_id !== "" &&
        this.state.vehicle_id
      ) {
        formData.set(
          "vehicle[subcontacts][" + subcontact_idx + "][subcontact_id]",
          val.subcontact_id
        );
        formData.set(
          "vehicle[subcontacts][" + subcontact_idx + "][relation_type_id]",
          val.relation_type_id
        );
        formData.set(
          "vehicle[subcontacts][" + subcontact_idx + "][start_date]",
          val.start_date
        );
        formData.set(
          "vehicle[subcontacts][" + subcontact_idx + "][end_date]",
          val.end_date
            ? val.end_date
            : new Date()
                .toISOString()
                .slice(0, 19)
                .replace("T", " ")
        );
        formData.set(
          "vehicle[subcontacts][" + subcontact_idx + "][has_car_doc_documents]",
          val.has_car_doc_documents
        );
        formData.set(
          "vehicle[subcontacts][" + subcontact_idx + "][deleted_at]",
          new Date()
            .toISOString()
            .slice(0, 19)
            .replace("T", " ")
        );
        subcontact_idx++;
      }
    });

    if (this.state.files) {
      this.state.files.map((val, idx) => {
        formData.set(`media[${idx}]`, val);
      });
    }

    if (this.state.wallet_files) {
      this.state.wallet_files.map((val, idx) => {
        formData.set(`wallet[${idx}]`, val);
      });
    }
    let self = this;
    const token = localStorage.getItem("userToken");
    if (this.state.action === "new") {
      axios
        .post(api.vehicles().post(), formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`
          }
        })
        .then(response => {
          self.handleCloseBackdrop();
          self.setState({ errors: false });
          self.setState({ save_vehicle: true });
          self.setState({ message: "Vehículo creado con éxito!" });
          self.setState({ dialogOpen: true });
        })
        .catch(function(error) {
          var message =
            "Hubo un problema al guardar el vehículo. Por favor volver a intentar";
          if (error.response.data.errors["vehicle.plate"]) {
            message = "El vehículo ya existe. Por favor revisar.";
          }
          self.setState({ errors: true });
          self.setState({ message: message });
          self.setState({ dialogOpen: true });
          self.handleCloseBackdrop();
        });
    } else {
      formData.set("vehicle[id]", this.state.vehicle_id);
      formData.append("_method", "patch");
      axios
        .post(api.vehicles().patch(this.state.vehicle_id), formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`
          }
        })
        .then(response => {
          self.setState({ save_vehicle: true });
          self.setState({ errors: false });
          self.setState({ message: "Vehículo modificado con éxito!" });
          self.setState({ dialogOpen: true });
          self.handleCloseBackdrop();
        })
        .catch(function(error) {
          self.setState({ errors: true });
          self.setState({
            message:
              "Hubo un problema al guardar el vehículo. Por favor volver a intentar"
          });
          self.setState({ dialogOpen: true });
          self.handleCloseBackdrop();
        });
    }
  };

  getStepContent(step) {
    var disabled = this.state.disabled;
    const steps = [
      "Vehículo",
      "Vencimientos/Garantía/Service",
      "Cliente",
      "Seguro",
      "Ubicación",
      "Cubiertas",
      "Financiero/Venta",
      "Datos Compra",
      "Otros"
    ];

    switch (step) {
      case "Vehículo":
        return [
          <div>
            <BasicDataComponent
              onChange={this.handleChange}
              disabled={this.state.disabled}
              error={this.state.errors}
              title={"Datos del vehículo"}
              basic_data={this.state.basic_data}
              fleet_types={this.state.fleet_types}
              brands={this.state.brands}
              models={this.state.models}
              versions={this.state.versions}
              colors={this.state.colors}
              owner_types={this.state.owner_types}
              vtv_provinces={this.state.provinces}
              vtv_cities={this.state.vtv_cities}
              plate_provinces={this.state.provinces}
              plate_cities={this.state.cities}
              clients={this.state.clients}
              vehicle_states={this.state.vehicle_states}
              condition_types={this.state.condition_types}
              investor_providers={this.state.investor_providers}
              onValidatePlate={this.validatePlate}
              plate_exists={this.state.plate_exists}
              version={this.state.basic_data.version}
              variation={this.state.basic_data.version.variation}
              sap_projects={this.state.sap_projects}
            />
          </div>
        ];
      case "Vencimientos/Garantía/Service":
        return [
          <div>
            <ExpirationsComponent
              onChange={this.handleChange}
              disabled={this.state.disabled}
              error={this.state.errors}
              vtv_provinces={this.state.provinces}
              vtv_cities={this.state.vtv_cities}
              title={"Vencimientos"}
              expirations={this.state.expirations}
              send_expiriation_mailing_options={
                this.state.send_expiriation_mailing_options
              }
              mailing_weeks={this.state.mailing_weeks}
            />
            <WarrantyComponent
              onChange={this.handleChange}
              disabled={this.state.disabled}
              error={this.state.errors}
              title={"Garantía"}
              warranty={this.state.warranty}
              warranty_states={this.state.warranty_states}
            />
            <ServiceComponent
              onChange={this.handleChange}
              disabled={this.state.disabled}
              error={this.state.errors}
              title={"Service"}
              service={this.state.service}
              service_origins={this.state.service_origins}
              maintenance_plans={this.state.maintenance_plans}
            />
          </div>
        ];
      case "Cliente":
        return [
          <div>
            <ClientComponent
              onChange={this.handleChange}
              disabled={this.state.disabled}
              error={this.state.errors}
              title={"Datos Cliente"}
              client_data={this.state.client_data}
              contracts={this.state.contracts}
              authorization_matrices={
                parseInt(this.state.basic_data.is_fleet_owner) === 1
                  ? this.state.authorization_matrices_ac
                  : this.state.authorization_matrices
              }
              policies={
                parseInt(this.state.basic_data.is_fleet_owner) === 1
                  ? this.state.policies_ac
                  : this.state.policies
              }
              client_structures={this.state.client_structures}
              has_circulation={this.state.has_circulation}
              is_fleet_owner={this.state.basic_data.is_fleet_owner}
              vehicle_state={this.state.vehicle_state}
            />
            <RelatedContactComponent
              onChange={this.handleChange}
              disabled={this.state.disabled}
              error={this.state.errors}
              title={"Contactos relacionados"}
              related_contact={this.state.related_contact}
              subcontacts={this.state.subcontacts}
              subcontact_relation_types={this.state.subcontact_relation_types}
              addNewItem={this.addNewItem}
              removeItem={this.removeItem}
              is_fleet_owner={this.state.basic_data.is_fleet_owner}
              booking={this.state.active_booking[0]}
            />
            <BookingComponent
              disabled={this.state.disabled}
              title={"Reserva Activa"}
              booking={this.state.active_booking[0]}
            />
          </div>
        ];
      case "Seguro":
        return [
          <div>
            <InsuranceComponent
              onChange={this.handleChange}
              disabled={this.state.disabled}
              error={this.state.errors}
              title={"Seguro"}
              insurance={this.state.insurance}
              insurance_history={this.state.insurance_history}
              insurances={this.state.insurances}
              active_booking={this.state.active_booking[0]}
            />
          </div>
        ];
      case "Ubicación":
        return [
          <div>
            <AddressesComponent
              onChange={this.handleChange}
              disabled={this.state.disabled}
              error={this.state.errors}
              title={"Ubicaciones"}
              contact_addresses={this.state.contact_addresses}
              addresses={this.state.addresses}
              addNewItem={this.addNewItem}
              removeItem={this.removeItem}
            />
          </div>
        ];
      case "Cubiertas":
        return [
          <div>
            <TiersComponent
              onChange={this.handleChange}
              disabled={this.state.disabled}
              error={this.state.errors}
              title={"Cubiertas"}
              tiers={this.state.tiers_data}
              tier_variations={this.state.tier_variations}
              tier_brands={this.state.tier_brands}
            />
          </div>
        ];
      case "Financiero/Venta":
        return [
          <div>
            <FinancialAndSaleComponent
              onChange={this.handleChange}
              disabled={this.state.disabled}
              error={this.state.errors}
              sales_title={"Datos Venta"}
              financial_title={"Datos Financieros"}
              financial_sales={this.state.financial_sales}
              buyer_contacts={this.state.buyer_contacts}
              onContactsSearch={this.handleContactsAsyncSearch}
            />
            <SalesData
              onChange={this.handleChange}
              disabled={this.state.disabled}
              error={this.state.errors}
              sales_data={this.state.sales_data}
              sale_data_title={"Datos Venta"}
              buyer_contacts={this.state.buyer_contacts}
              reseller_contacts={this.state.reseller_contacts}
              onContactsSearch={this.handleContactsAsyncSearch}
            />
          </div>
        ];
      case "Datos Compra":
        return [
          <div>
            <PurchaseComponent
              onChange={this.handleChange}
              disabled={this.state.disabled}
              error={this.state.errors}
              purchase_title={"Datos Compra"}
              purchase={this.state.purchase}
              comments={this.state.comments}
              provinces={this.state.provinces}
              carstore_contacts={this.state.carstore_contacts}
              onContactsSearch={this.handleContactsAsyncSearch}
              clients={this.state.clients}
            />
          </div>
        ];

      case "Otros":
        return [
          <div>
            <EquipmentComponent
              onChange={this.handleChange}
              disabled={this.state.disabled}
              error={this.state.errors}
              title={"Equipamiento"}
              equipment={this.state.equipment}
              equipment_types={this.state.equipment_types}
              gps_providers={this.state.gps_providers}
              has_duplicated_key_boolean={this.state.has_duplicated_key_boolean}
              addNewItem={this.addNewItem}
              removeItem={this.removeItem}
              fuel_providers={this.state.fuel_providers}
            />

            <PreferencesComponent
              onChange={this.handleChange}
              disabled={this.state.disabled}
              error={this.state.errors}
              title={"Proveedores preferidos"}
              title_not_preferences={"Proveedores excluidos"}
              preferences={this.state.preferences}
              not_preferences={this.state.not_preferences}
              providers={this.state.providers}
              addNewItem={this.addNewItem}
              removeItem={this.removeItem}
              onProvidersSearch={this.handleProvidersAsyncSearch}
            />
            <Row>
              <Col>
                <MediaComponent
                  media={this.state.media}
                  onChange={this.handleUpload}
                  disabled={this.state.disabled}
                  title={"Adjuntos"}
                />
              </Col>
              <Col>
                <MediaComponent
                  media={this.state.wallet}
                  onChange={this.handleWalletUpload}
                  disabled={this.state.disabled}
                  acceptedFiles={[".pdf"]}
                  qAcceptedFiles={5}
                  title={"Documentacion App Mobile"}
                  showDelete={true}
                  onRefresh={this.onMediaRefresh}
                />
              </Col>
            </Row>
            <HansaMediaComponent
              hansa_code={this.state.basic_data.plate}
              model="Vehicle"
            />
          </div>
        ];
      default:
        return [<div></div>];
    }
  }

  handleValidations = step => {
    if (this.state.action !== "view") {
      switch (step) {
        case "Vehículo":
          var validation =
            this.state.basic_data.plate !== "" &&
            this.state.basic_data.version_id !== "" &&
            this.state.basic_data.year !== "" &&
            this.state.basic_data.is_owner !== "" &&
            this.state.basic_data.is_fleet_owner !== "" &&
            this.state.basic_data.vehicle_state_id !== "1" &&
            this.state.basic_data.vehicle_state_id !== ""
              ? true
              : false;
          validation = validation && !this.state.plate_exists;
          var version = this.state.versions.filter(
            version =>
              parseInt(version.id) ===
              parseInt(this.state.basic_data.version_id)
          );
          /*if (version[0].infoauto_codia) {
            validation = validation && this.state.basic_data.year >= version[0].infoauto_start_year && this.state.basic_data.year <= version[0].infoauto_end_year;
          }*/
          if (parseInt(this.state.basic_data.is_fleet_owner) === 1) {
            //							validation = validation || (this.state.basic_data.color !== '')
            var renting_description = version[0].renting_description;
            validation = validation && renting_description !== "";
          }

          var vehicle_state = this.state.vehicle_states.filter(
            state =>
              parseInt(state.id) ===
              parseInt(this.state.basic_data.vehicle_state_id)
          );
          if (vehicle_state[0]) {
            if (vehicle_state[0].hansa_code === "PREALTA") {
              return validation;
            }
          }

          var last_km_date = this.state.basic_data.last_km_date;
          var today = new Date();
          if (last_km_date) {
            validation =
              validation && new Date(last_km_date).getTime() <= today.getTime();
          }
          validation = validation && this.state.basic_data.chassis !== "";
          validation = validation && this.state.basic_data.motor_number !== "";

          return validation;

        case "Vencimientos/Garantía/Service":
          var vehicle_state = this.state.vehicle_states.filter(
            state =>
              parseInt(state.id) ===
              parseInt(this.state.basic_data.vehicle_state_id)
          );
          var version = this.state.versions.filter(
            version =>
              parseInt(version.id) ===
              parseInt(this.state.basic_data.version_id)
          );
          var maintenance_plan = version[0].maintenance_plan_version
            ? version[0].maintenance_plan_version
            : null;
          if (vehicle_state[0]) {
            if (
              vehicle_state[0].name === "DISPONIBLE" ||
              vehicle_state[0].name === "ACTIVO GESTION FLOTAS"
            ) {
              if (
                maintenance_plan.length === 0 &&
                (!this.state.service.maintenance_plan_id ||
                  parseInt(this.state.service.maintenance_plan_id) === 0 ||
                  this.state.service.maintenance_plan_id === "")
              ) {
                return false;
              }
            }
          }

          return true;
        case "Cliente":
          if (
            this.state.basic_data.is_fleet_owner === 1 ||
            this.state.basic_data.is_fleet_owner === "1"
          ) {
            if (
              this.state.client_data.policy_id !== "" &&
              this.state.client_data.authorization_matrix_id !== "" &&
              this.state.client_data.policy_id !== undefined &&
              this.state.client_data.authorization_matrix_id !== undefined
            ) {
              return true;
            } else {
              return false;
            }
          }
          var validation =
            this.state.client_data.contract_id !== "" &&
            this.state.client_data.policy_id !== "" &&
            this.state.client_data.contract_id !== undefined &&
            this.state.client_data.policy_id !== undefined &&
            this.state.client_data.authorization_matrix_id !== "" &&
            this.state.client_data.authorization_matrix_id !== undefined &&
            this.state.client_data.hansa_start_date !== ""
              ? true
              : false;
          //validation = validation && (this.state.related_contact.subcontact_ids[0].subcontact_id !== '' && this.state.related_contact.subcontact_ids[0].relation_type_id === '' )
          var vehicle_state = this.state.vehicle_states.filter(
            state =>
              parseInt(state.id) ===
              parseInt(this.state.basic_data.vehicle_state_id)
          );
          var contract = this.state.contracts.filter(
            contract =>
              parseInt(contract.id) ===
              parseInt(this.state.client_data.contract_id)
          )[0];
          var hansa_end_date_in_contract = true;
          if (vehicle_state[0]) {
            if (contract && vehicle_state[0].name === "BAJA GESTION FLOTAS") {
              hansa_start_date_in_contract = this.state.client_data
                .hansa_start_date
                ? this.state.client_data.hansa_start_date >=
                  this.formatDate(contract.hansa_start_date)
                  ? true
                  : false
                : false;
              hansa_end_date_in_contract = this.state.client_data.hansa_end_date
                ? this.state.client_data.hansa_end_date <=
                  this.formatDate(contract.hansa_end_date)
                  ? true
                  : false
                : false;

              if (!contract.hansa_end_date) hansa_end_date_in_contract = true;
            }
          }
          var hansa_start_date_in_contract = true;
          validation =
            validation &&
            this.state.client_data.hansa_start_date !== "" &&
            this.state.client_data.hansa_start_date !== null;
          if (contract && contract.hansa_start_date) {
            hansa_start_date_in_contract =
              this.state.client_data.hansa_start_date >=
              this.formatDate(contract.hansa_start_date)
                ? true
                : false;
          } else {
            hansa_start_date_in_contract = false;
          }

          validation =
            validation &&
            hansa_start_date_in_contract &&
            hansa_end_date_in_contract;
          /*
							else {
								if (this.state.client_data.hansa_end_date !== '' && this.state.client_data.hansa_end_date !== undefined){
									validation = validation && (this.state.client_data.hansa_end_date <= this.state.client_data.contract.hansa_end_date)
								}
							}
						}*/
          var has_driver = false;
          var has_driver_car_doc = false;
          this.state.related_contact.subcontact_ids.map((val, idx) => {
            if (
              val.subcontact_id !== "" &&
              (val.relation_type_id === "2" || val.relation_type_id === 2)
            ) {
              has_driver = true;
              if (val.has_car_doc_documents !== "" && val.start_date !== "") {
                has_driver_car_doc = true;
              }
            }
          });
          if (vehicle_state[0].name === "BAJA GESTION FLOTAS") {
            has_driver = true;
            has_driver_car_doc = true;
          }

          validation = validation && has_driver && has_driver_car_doc;
          //						validation = validation && (this.state.related_contact.subcontact_ids[0].has_car_doc_documents !== '' && this.state.related_contact.subcontact_ids[0].relation_type_id === '2' )
          return validation;
        case "Seguro":
          return true;
        case "Ubicación":
          return true;
        case "Cubiertas":
          return true;
        case "Financiero/Venta":
          return true;
        case "Otros":
          validation = true;
          var vehicle_state = this.state.vehicle_states.filter(
            state =>
              parseInt(state.id) ===
              parseInt(this.state.basic_data.vehicle_state_id)
          );
          if (vehicle_state[0]) {
            if (vehicle_state[0].hansa_code === "BAJA") {
              validation =
                parseInt(this.state.equipment.gps_provider_id) > 1
                  ? false
                  : true;
            }
          }
        default:
          return true;
      }
    } else {
      return true;
    }
  };

  validatePlate = async () => {
    var plate = this.state.basic_data.plate;
    var plate_exists = false;
    if (this.state.basic_data.id !== "") {
      var vehicle = await this.getApi(api.vehicles().autocomplete(plate));
      if (vehicle) {
        if (vehicle[0]) {
          plate_exists = true;
        }
      }
    }
    this.setState({ plate_exists: plate_exists });
  };

  handleProvidersAsyncSearch = values => {
    var provider = values;
    const token = localStorage.getItem("userToken");
    if (provider.length > 2) {
      return axios
        .get(api.providers().index(1, provider, "", "", "", ""), {
          headers: { Authorization: `Bearer ${token}` }
        })
        .then(res => {
          var providers = this.state.providers;
          providers.options = res.data.data;
          this.setState({ providers: providers });
        })
        .catch(err => {
          console.log(err);
        });
    }
  };
  handleContactsAsyncSearch = values => {
    var contact = values;
    const token = localStorage.getItem("userToken");
    if (contact.length > 2) {
      return axios
        .get(api.contacts().autocomplete(contact), {
          headers: { Authorization: `Bearer ${token}` }
        })
        .then(res => {
          var buyer_contacts = this.state.buyer_contacts;
          buyer_contacts.options = res.data;
          var carstore_contacts = this.state.carstore_contacts;
          carstore_contacts.options = res.data;
          this.setState({
            buyer_contacts: buyer_contacts,
            carstore_contacts: carstore_contacts,
          });
        })
        .catch(err => {
          console.log(err);
        });
    }
  };

  handleCloseBackdrop = () => {
    var backdrop = !this.state.backdrop;
    this.setState({ backdrop: backdrop });
  };

  render() {
    const { submitted, errors } = this.state;

    const steps = [
      "Vehículo",
      "Vencimientos/Garantía/Service",
      "Cliente",
      "Seguro",
      "Ubicación",
      "Cubiertas",
      "Financiero/Venta",
      "Datos Compra",
      "Otros"
    ];

    const handleBackStep = () => {
      if (this.handleValidations(steps[this.state.activeStep]) === true) {
        this.setState({ errors: "" });
        this.setState({ activeStep: this.state.activeStep - 1 });
      }
    };

    const handleNextStep = () => {
      if (this.handleValidations(steps[this.state.activeStep]) === true) {
        this.setState({ errors: "" });
        this.setState({ activeStep: this.state.activeStep + 1 });
      } else {
        this.setState({
          dialogOpen: true,
          message:
            "Hay errores en la carga o faltan carga campos. Por favor revisar",
          errors: true
        });
      }
    };

    const handleStepChange = (e, step) => {
      e.preventDefault();
      if (this.handleValidations(steps[this.state.activeStep]) === true) {
        this.setState({ errors: "" });
        this.setState({ activeStep: step });
      } else {
        this.setState({
          dialogOpen: true,
          message:
            "Hay errores en la carga o faltan carga campos. Por favor revisar",
          errors: true
        });
      }
    };

    const handleRedirect = url => () => {
      url = this.state.action === "new" ? "/vehicles" : "/vehicles";
      window.location.href = url;
    };

    const handleDialogClose = () => {
      this.setState({
        dialogOpen: false,
        meesage: "",
        error: "",
        delete_feature: "",
        address_id: "",
        feature_deleted: false
      });
    };

    const handleDialogCancelClose = () => {
      this.setState({ cancel_dialog: false });
    };

    const confirmCancel = () => {
      this.setState({ cancel_dialog: true });
    };
    return (
      <Container fluid className="main-content-container px-4 pb-4">
        <Row noGutters className="page-header pt-4">
          <PageTitle sm="4" title="Vehículo" className="text-sm-left" />
        </Row>
        <Row>
          <Col md="12">
            <React.Fragment>
              {this.state.dialogOpen ? (
                <Dialog
                  open={this.state.dialogOpen}
                  fullWidth
                  aria-labelledby="responsive-dialog-title"
                >
                  <DialogTitle id="responsive-dialog-title">
                    {"Vehículo"}
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText>{this.state.message}</DialogContentText>
                  </DialogContent>
                  <DialogActions disableSpacing="false">
                    {this.state.errors ? (
                      <Button
                        onClick={handleDialogClose}
                        variant="contained"
                        color="primary"
                      >
                        Aceptar
                      </Button>
                    ) : (
                      ""
                    )}
                    {this.state.save_vehicle ? (
                      <Button
                        onClick={handleRedirect()}
                        variant="contained"
                        color="primary"
                      >
                        Aceptar
                      </Button>
                    ) : (
                      ""
                    )}
                  </DialogActions>
                </Dialog>
              ) : (
                ""
              )}
              {this.state.cancel_dialog ? (
                <Dialog
                  open={this.state.cancel_dialog}
                  fullWidth
                  aria-labelledby="responsive-dialog-title"
                >
                  <DialogTitle id="responsive-dialog-title">
                    {"Vehículo"}
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText>
                      ¿Esta seguro que desea cancelar?
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions disableSpacing="false">
                    <Button
                      onClick={handleRedirect()}
                      variant="contained"
                      color="primary"
                      className="mr-1"
                    >
                      Aceptar
                    </Button>
                    <Button
                      onClick={handleDialogCancelClose}
                      variant="contained"
                      color="primary"
                    >
                      Cancelar
                    </Button>
                  </DialogActions>
                </Dialog>
              ) : (
                ""
              )}

              {this.state.loading ? (
                <LinearProgress />
              ) : (
                <div>
                  <form onSubmit={this.handleSubmit}>
                    <div className="row">
                      <div className="col-md-10 mx-auto">
                        <div className="stepper">
                          <Stepper
                            activeStep={this.state.activeStep}
                            style={{
                              background: "inherit",
                              paddingTop: "12px",
                              paddingBottom: "12px"
                            }}
                          >
                            {steps.map((label, idx) => (
                              <Step key={label}>
                                <StepLabel
                                  onClick={e => {
                                    handleStepChange(e, idx);
                                  }}
                                  style={{ cursor: "pointer" }}
                                >
                                  {label}
                                </StepLabel>
                              </Step>
                            ))}
                          </Stepper>
                        </div>
                      </div>
                    </div>
                    <Typography>
                      <div className="row" className="mx-1">
                        {this.getStepContent(steps[this.state.activeStep])}
                      </div>
                    </Typography>
                    <div className="mt-1">
                      {this.state.action === "view" ? (
                        <Button
                          variant="contained"
                          className="mt-3 ml-1 mr-1"
                          color="secondary"
                          href={"/vehicles"}
                        >
                          Volver
                        </Button>
                      ) : (
                        <Button
                          variant="contained"
                          className="mt-3 ml-1 mr-1"
                          color="secondary"
                          onClick={confirmCancel}
                        >
                          Cancelar
                        </Button>
                      )}
                      <Button
                        variant="contained"
                        className="mt-3 ml-1 mr-1"
                        disabled={this.state.activeStep === 0}
                        onClick={handleBackStep}
                      >
                        Anterior
                      </Button>
                      {this.state.activeStep === steps.length - 1 ? (
                        ""
                      ) : (
                        <Button
                          variant="contained"
                          className="mt-3 ml-1 mr-1"
                          color="primary"
                          onClick={handleNextStep}
                        >
                          Siguiente
                        </Button>
                      )}
                      {this.state.action === "edit" ||
                      (this.state.action === "new" &&
                        this.state.activeStep >= 3) ? (
                        <React.Fragment>
                          <Button
                            type="submit"
                            variant="contained"
                            className="mt-3 ml-1 mr-1"
                            color="primary"
                          >
                            Guardar
                          </Button>
                        </React.Fragment>
                      ) : (
                        ""
                      )}
                    </div>
                  </form>
                </div>
              )}
            </React.Fragment>
          </Col>
        </Row>
        <React.Fragment>
          <Backdrop
            open={this.state.backdrop}
            onClick={this.handleCloseBackdrop}
            style={{ zIndex: 10000, color: "#3f51b5" }}
          >
            <Typography className="ml-2" variant="h5" color="primary">
              Guardando...
            </Typography>
          </Backdrop>
        </React.Fragment>
      </Container>
    );
  }
}

export default VehicleForm;
